const ReferTitle = ({ title }) => {
  return (
    <p className="text-2xl font-extrabold text-main-color mb-[10px]">{title}</p>
  );
};

export default ReferTitle;
